const INITIAL_STATE = {
    data: [],
    loading: false,
    error: false
};

export default function dashboard(state = INITIAL_STATE, action){
    switch (action.type){
        case "GET_DASHBOARD":
            return { ...state, loading: true }
        case "SUCCESS_GET_DASHBOARD":
            return { data: action.payload.data, loading: false, error: false }
        case "FAILURE_GET_DASHBOARD":
            return { data: [], loading: false, error: true }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/dashboard.js